import React from 'react';
import { Row, Col, Form, Button, Icon, Progress } from 'antd';
import InputCurrency, { currency2Float } from '~/components/UI/InputCurrency';
import { InstallmentsTable } from '../Tables/InstallmentsTable';
import { VincularCobrancaSwitch } from './VincularCobrancaSwitch';
import { PERMISSIONS } from '~/constants/permissions.constants';
import { get } from 'lodash';

var getInputName = function(category) {
    switch(category){
        case 1: return 'Honorário de abertura';
        case 2: return 'Honorário de alteração';
        case 3: return 'Honorário de encerramento';
        case 4: return 'Serviço extra';
        case 5: return 'Honorário de troca de contabilidade';
        default: return 'Serviço extra';
    }
}

var cardStyle = {
    padding: '14px 20px',
    borderRadius: 10,
    border: '1.5px solid #e8e8e8',
    background: '#fff',
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    marginBottom: 10,
};

var iconBoxStyle = {
    width: 36,
    height: 36,
    borderRadius: 8,
    background: '#f5f5f5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
};

export var Financial = function(props) {
    var data = props.data;
    var form = props.form;
    var user = props.user;
    var billsPayment = props.billsPayment;
    var billsData = props.billsData;
    var setBillsData = props.setBillsData;
    var openBillForm = props.openBillForm;
    var category = props.category;

    var payment = billsPayment;
    var getFieldDecorator = form.getFieldDecorator;
    var getFieldValue = form.getFieldValue;

    var getPaymentPercentage = function(payment) {
        // Cobranca sem parcela dividia por zero e devolvia NaN para a barra.
        if (!payment || !Array.isArray(payment.installments) || payment.installments.length === 0) {
            return 0;
        }
        var paidInstallments = payment.installments.filter(function(installment) { return installment.status === 'Pago'; });
        return Math.round((100 * paidInstallments.length) / payment.installments.length);
    }

    var createBills = function(val) {
        if (val) {
          openBillForm({
            task_name: form.getFieldValue('task') || getInputName(category),
            total: form.getFieldValue('amount')
          });
        } else {
          setBillsData(null);
        }
    }

    var canManageBills = user.permissions.includes(PERMISSIONS.corporate.createBillsToPay);
    var fieldAmount = getFieldValue('amount');
    var typedAmount = (fieldAmount !== undefined ? fieldAmount : get(data, 'custom_fields.amount', 0)) || 0;

    return (
        <Row style={{ margin: '-15px' }}>
            <Col span={24}>
                {!payment && (
                    <div>
                        {/* Amount card with Vincular cobrança switch on the right */}
                        <div style={cardStyle}>
                            <div style={iconBoxStyle}>
                                <Icon type="dollar" style={{ fontSize: 17, color: '#595959' }} />
                            </div>
                            <div style={{ flex: 1 }}>
                                <div style={{ fontWeight: 600, fontSize: 14, color: '#262626', marginBottom: 6 }}>
                                    {getInputName(category)}
                                </div>
                                <Form.Item style={{ marginBottom: 0 }}>
                                    {getFieldDecorator('amount', {
                                        initialValue: get(data, 'custom_fields.amount', 0),
                                        normalize: function(value) { return currency2Float(value); }
                                    })(
                                        <InputCurrency style={{ maxWidth: 220 }} />
                                    )}
                                </Form.Item>
                            </div>
                            {data.id && (
                                <VincularCobrancaSwitch
                                    checked={!!billsData}
                                    disabled={!canManageBills || typedAmount <= 0}
                                    onChange={createBills}
                                    style={{ marginTop: 0, marginBottom: 0, flexShrink: 0 }}
                                />
                            )}
                        </div>
                    </div>
                )}

            </Col>

            {(payment || billsData) && (
                <Col span={24}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        <span>Parcelas</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                            {payment && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <span style={{ fontSize: 13, color: '#8c8c8c', whiteSpace: 'nowrap' }}>Status do Pagamento:</span>
                                    <Progress percent={getPaymentPercentage(payment)} style={{ width: 120, marginBottom: 0 }} size="small" />
                                </div>
                            )}
                            <Button
                                disabled={!user.permissions.includes(PERMISSIONS.extraServices.edit)}
                                onClick={createBills}
                                type="primary"
                            >
                                Editar
                            </Button>
                        </div>
                    </div>
                    <InstallmentsTable
                        payment={payment}
                        billsData={billsData}
                    />
                </Col>
            )}
        </Row>
    );
}

export default Financial;
 
 
